import DebtsTab from "../../Components/DebtsTab/DebtsTab";
import Page from "../../Components/MetaPage/Page";
import TotalDebts from "../../Components/TotalDebts/TotalDebts";
import { getRemoteValue } from "../../Utils/firebase";

const PaymentsPage = () => {
  return (
    <Page title={getRemoteValue("payments")}>
      <div className="md:p-[4%] lg:p-[6%] !py-0">
        <TotalDebts />
        <DebtsTab />
      </div>
    </Page>
  );
};

export default PaymentsPage;
